var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"libramiento puiformheader"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('pui-field',{attrs:{"label":this.$t('libramiento.xxxx'),"value":_vm.getXXXX}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }